{
  "common" : {
    "px" : "px",
    "px_uppercase" : "PX",
    "seconds" : "segundos",
    "other" : "-- Otro --",
    "customFieldExistsError" : "Ya existe un campo personalizado con este nombre",
    "uniqueKeyNotUniqueError" : "Esta clave no es única",
    "save" : "Guardar",
    "saving" : "Guardando",
    "typeAnOption" : "Escriba una opción",
    "unsaved" : "No guardado",
    "noSubmissionsFound" : "No se han encontrado envíos",
    "sortBy" : "Filtrar por",
    "clearAll" : "Borrar todo",
    "submitSurvey" : "Enviar encuesta",
    "select" : "Seleccionar",
    "data" : "datos",
    "disqualifyAfterSubmitLower" : "Descalificar después de enviar",
    "errorRetryAgain" : "Error, vuelve a intentarlo",
    "bubbleRadioStyleImageAlt" : "Estilo de botón de opción burbuja",
    "standardRadioStyleImageAlt" : "Estilo estándar de botón de opción",
    "recurringFrequency" : {
      "once" : "Una vez",
      "daily" : "Por día",
      "weekly" : "Semanal",
      "monthly" : "Mensual",
      "yearly" : "Anual"
    },
    "yes" : "Sí",
    "no" : "No",
    "updated" : "Actualizado",
    "new" : "Nuevo",
    "title" : "Título",
    "openSettings" : "Abrir configuración",
    "cloneField" : "Clonar campo",
    "removeField" : "Eliminar campo",
    "description" : "Descripción",
    "cannotAddThisField" : "No puede añadir este campo",
    "overallOnly" : "Solo general",
    "nextSlideDefault" : "Diapositiva siguiente (por defecto)",
    "nextQuestion" : "Siguiente pregunta",
    "searchAddress" : "Buscar dirección",
    "recurringDonation" : "Donación Recurrente",
    "recurringDonationDay" : "Donación recurrente de 1 día",
    "recurringDonationWeek" : "Donación recurrente de 1 semana",
    "recurringDonationMonth" : "Donación recurrente de 1 mes",
    "recurringDonationYear" : "Donación recurrente de 1 año",
    "integrate" : "Integrar",
    "preview" : "Previsualizar",
    "back" : "Atrás",
    "alert" : "Alerta",
    "proceed" : "Proceder",
    "confirm" : "Confirmar",
    "cancel" : "Cancelar",
    "delete" : "Borrar",
    "embed" : "Insertar",
    "link" : "Enlazar",
    "linkModal" : {
      "title" : "Insertar enlace",
      "urlLabel" : "URL",
      "urlPlaceholder" : "https://www.ejemplo.com",
      "invalidUrl" : "La URL no es válida"
    },
    "iframeEmbed" : "Incrustación de iframe",
    "styles" : "Estilos",
    "options" : "Opciones",
    "quickAdd" : "Añadir rápidamente",
    "customFields" : "Campos personalizados",
    "addObjectFields" : "Añadir campos de objeto",
    "personalInfo" : "Información personal",
    "contactInfo" : "Información de contacto",
    "submit" : "Enviar",
    "address" : "Dirección",
    "customized" : "Personalizado",
    "layout" : "Diseño",
    "showLabel" : "Mostrar etiqueta",
    "showImage" : "Mostrar imagen",
    "imageLayout" : "Imagen Alineación del contenido",
    "imageLayoutSettings" : "Configuración de Alineación del contenido de Imagen",
    "imageLayoutMode" : "Modo de Alineación del contenido de la Imagen",
    "surveyDefault" : "Predeterminado de la encuesta",
    "independent" : "Independiente",
    "image" : "Imagen",
    "desktop" : "Escritorio",
    "mobile" : "Móvil",
    "desktopImage" : "Imagen de Escritorio",
    "mobileImage" : "Imagen de móvil",
    "uploaded" : "Subido",
    "changeImage" : "Cambiar imagen",
    "uploadImage" : "Subir una imagen",
    "remove" : "Eliminar",
    "background" : "Fondo",
    "buttonBackground" : "Fondo del Botón",
    "fontColour" : "Color de la Fuente",
    "textFontColour" : "Color de la fuente del texto",
    "subTextFontColour" : "Color de la fuente del subtexto",
    "selectThemes" : "Seleccionar tema",
    "selectOne" : "Seleccionar uno",
    "enableIcon" : "Habilitar icono",
    "iconType" : "Tipo de icono",
    "iconPlacement" : "Colocación de Iconos",
    "filled" : "Rellenado",
    "textOnly" : "Solo cuerpo",
    "border" : "Borde",
    "borderType" : "Tipo de borde",
    "px" : "px",
    "cornerRadius" : "Radio de la esquina",
    "width" : "Ancho",
    "padding" : "Margen",
    "top" : "Superior",
    "bottom" : "Inferior",
    "left" : "Izquierda",
    "right" : "Derecha",
    "center" : "Centrar",
    "default" : "Por defecto",
    "formDefault" : "Formulario por defecto",
    "shadow" : "Sombra",
    "color" : "Color",
    "horizontal" : "Horizontal",
    "vertical" : "Vertical",
    "blur" : "Difuminar",
    "spread" : "Propagar",
    "fieldStyle" : "Estilo de campo",
    "fontColor" : "Color de la fuente",
    "inputTextFillColor" : "Color de relleno del comentario/opinión",
    "inputTextColor" : "Color del texto del comentario",
    "primaryColor" : "Color principal",
    "primaryColorTooltip" : "Controla el Color para el estado de desplazamiento y el estado Dinámico.",
    "inputTextColorTooltip" : "Controla el Color del texto escrito en los Campos de comentario/opinión.",
    "mapPrimaryColorToButtonColor" : "Asigna el color principal al color del botón",
    "label" : "Etiqueta",
    "fontFamily" : "Familia tipográfica",
    "size" : "Tamaño",
    "weight" : "Peso",
    "fontWeightTooltip" : "Aplicable en caso de párrafos",
    "fontWeightOptions" : {
      "thin" : "100 - Fino",
      "extraLight" : "200 - Extraligero",
      "light" : "300 - Ligero",
      "normal" : "400 - Normal",
      "medium" : "500 - Medio",
      "semiBold" : "600 - Seminegrita",
      "bold" : "700 - Negrita"
    },
    "placeholder" : "Marcador de posición",
    "customCSS" : "CSS personalizado",
    "backgroundImage" : "Imagen de fondo",
    "headerImage" : "Imagen de cabecera",
    "miscellaneous" : "Miscelánea",
    "agencyBranding" : "Elementos de marca de la agencia",
    "imageUploadMessage" : "Haz clic o arrastra un archivo de imagen a esta área para subirlo",
    "backgroundImageTooltipMessage" : "La imagen de fondo está pensada para cubrir toda la página, proporcionando un telón de fondo visualmente atractivo para el formulario. Para ver la imagen de fondo, haz clic en la opción de previsualización.",
    "headerImageTooltipMessage" : "La imagen del encabezado está diseñada para cubrir todo el ancho del formulario y permanece posicionada en la parte superior del formulario. Para ver la imagen del encabezado, haz clic en la opción de previsualización.",
    "onSubmit" : "Al enviar",
    "facebookPixelID" : "ID de píxel de Facebook",
    "facebookPixelIDMessage" : "Ignora este campo si planeas usar este formulario/encuesta dentro de un embudo",
    "facebookPixelEvents" : "Eventos de píxel de Facebook",
    "onpageView" : "En vista de página",
    "stickyContact" : "Contacto fijo",
    "stickyContactMessage" : "Recuerda y completa automáticamente los datos del contacto cuando el usuario regresa en el mismo dispositivo y navegador.",
    "fieldDescription" : "Descripción del campo",
    "fieldTitle" : "Título del campo",
    "queryKey" : "Clave de consulta",
    "querykeyTooltipMessage" : "La clave de consulta que puede usarse como parámetro de URL para rellenar este campo",
    "required" : "Obligatorio",
    "hidden" : "Oculto",
    "hiddenValue" : "Valor oculto",
    "enableCountryPicker" : "Habilitar el selector de países",
    "altText" : "Texto alternativo",
    "optionImageAlt" : "Option image",
    "bannerAlt" : "banner",
    "avatarAlt" : "Avatar Name",
    "alignment" : "Alineación",
    "imageWidth" : "Ancho de la imagen",
    "imageHeight" : "Altura de la imagen",
    "logic" : "Lógica",
    "pleaseInput" : "Introduce",
    "editHTML" : "Editar HTML",
    "textStyle" : "Estilo de texto",
    "subText" : "Subtexto",
    "text" : "Texto",
    "buttonStyle" : "Estilo de botón",
    "fullWidth" : "Ancho completo",
    "htmlMessage" : "El HTML personalizado va aquí",
    "htmlEditorHeader" : "JAVASCRIPT / HTML PERSONALIZADO",
    "htmlEditorBodyMessage" : "Añade tu código aquí",
    "scriptAdded" : "Script Added!",
    "sourceAdded" : "Source Added!",
    "yesSave" : "Sí, Guardar",
    "cancelKeep" : "Cancelar, mantener",
    "done" : "Hecho",
    "addElement" : "Añadir elemento",
    "addUrlLike" : "Por favor, incluya URLs válidas como",
    "doNotAddRelativePath" : "No añadas rutas relativas como",
    "or" : "o",
    "addCustomFields" : "Añadir campos personalizados",
    "customFieldSearch" : "Buscar por nombre",
    "enterSourceValue" : "Introduce el valor de origen",
    "shortLabel" : "Etiqueta corta",
    "shortLabelPlaceholder" : "Fuente a Etiqueta corta",
    "labelPlaceholder" : "Tipo una etiqueta",
    "fileUploadPlaceholder" : "Subir a Archivo",
    "imagePlaceholder" : "Image",
    "fillValuesPlaceholder" : "Rellenar valores",
    "customCSSTooltip" : "Los CSS personalizados tienen prioridad sobre el estilo del formulario y los temas y pueden tener un impacto en el estilo del tema.",
    "fontFamilyTooltip" : "El creador admite todo tipo de fuentes, aunque no puedas verla en la lista. Búscala en el menú desplegable.",
    "useGDPRCompliantFont" : "Usa una fuente compatible con el RGPD",
    "enableTimezone" : "Habilitar zona horaria",
    "inputStyle" : "Estilo de entrada",
    "conditionalLogicAlertOnSubmit" : "La lógica condicional tendrá prioridad sobre el mensaje/redirigirá aquí",
    "conditionalLogicAlertOnShowHide" : "La lógica condicional tendrá prioridad sobre la configuración oculta aquí",
    "placeholderFacebookPixelIdInput" : "Introduce el ID de píxel de Facebook",
    "doNotShowMessage" : "No mostrar de nuevo",
    "creatingForm" : "Creada tu Formulario...",
    "creatingSurvey" : "Creada tu Encuesta...",
    "creatingQuiz" : "Creada tu cuestionario...",
    "errorCreatingForm" : "Hay un error Creada tu formulario. Por favor, Vuelva a intentarlo.",
    "errorCreatingSurvey" : "Hay un error Creada tu Encuesta. Por favor, Vuelva a intentarlo.",
    "errorCreatingQuiz" : "Ha habido un error Creada tu cuestionario. Por favor, Vuelva a intentarlo.",
    "redirectMessage" : "Será redirigido a:",
    "themes" : {
      "themes" : "Temas",
      "alertThemeMessage" : "Cambiar de tema hará que se pierdan todas las modificaciones de estilo actuales.",
      "useTheme" : "Usar tema",
      "removeTheme" : "Eliminar tema"
    },
    "box" : "Cuadro",
    "line" : "Línea",
    "message" : "Mensaje",
    "openUrl" : "Redirigir a la URL",
    "borderTypeList" : {
      "dotted" : "Punteado",
      "dashed" : "Discontinuo",
      "solid" : "Liso",
      "none" : "Ninguno"
    },
    "button" : "Botón",
    "emailNotification" : "Notificación por correo electrónico",
    "emailNotificationSubheader" : "Recibir un correo electrónico cuando alguien rellene tu formulario",
    "subject" : "Asunto",
    "emailTo" : "Correo electrónico (Para)",
    "senderName" : "Nombre del remitente",
    "senderNameWarning" : "Tu (nombre de la subcuenta) se añadirá si se deja en blanco",
    "emailError" : "Se requiere al menos una dirección de correo electrónico",
    "emailTooltip" : "La primera dirección de correo electrónico está destinada al campo «Para». Cualquier dirección de correo electrónico posterior se incluirá en el campo «Cc».",
    "clear" : "Borrar",
    "filter" : "Filtrar",
    "noResults" : "No hay resultados",
    "search" : "Buscar",
    "showNotificationsSettings" : "Mostrar configuración de notificaciones",
    "emailServicePaid" : "Esta función es un servicio de pago y generará cargos en función del uso.",
    "integration" : "Integración",
    "validation" : {
      "fieldRequired" : "El campo es obligatorio",
      "maxLengthExceeded" : "Máx. Longitud excedida ({max} carácter)"
    },
    "securityValidation" : {
      "title" : "Problemas de seguridad detectados. No se permiten los siguientes elementos:",
      "cookieAccess" : "Acceso a cookies detectado (document.cookie). Esto no está permitido por razones de seguridad.",
      "storageAccess" : "localStorage.getItem() - no está permitido leer desde localStorage.",
      "evalUsage" : "No se permite el uso de eval() ya que puede ejecutar código arbitrario.",
      "dynamicFunction" : "No se permite la creación dinámica de funciones (new Function) por razones de seguridad.",
      "stringExecution" : "No se permite pasar cadenas a setTimeout/setInterval, ya que puede ejecutar código arbitrario. Utilice referencias de funciones en su lugar."
    },
    "products" : {
      "subscriptionBadge" : "Suscripción",
      "trialBadge" : "{days} días de prueba gratuita",
      "setupFee" : "Cuota única de configuración",
      "quantity" : "Cantidad",
      "productImageAlt" : "Imagen del producto",
      "bumpIconAlt" : "Icono de opción adicional"
    },
    "payment" : {
      "payments" : "Pagos",
      "connected" : "Conectado",
      "connect" : "Conectar",
      "liveModeOn" : "Modo en tiempo real",
      "status" : "Estado",
      "test" : "Prueba",
      "live" : "En tiempo real",
      "paymentFields" : "Campos de pago",
      "suggestAnAmount" : "Sugerir una cantidad",
      "recurringPayments" : "Pagos Recurrentes",
      "selectCurrency" : "Seleccionar moneda",
      "tagActiveBGColor" : "Color de la etiqueta activa",
      "includeOtherAmount" : "Incluir otra cantidad",
      "footerInfo" : "Información de pie de página",
      "paymentType" : "Tipo de pago",
      "sellProducts" : "Vender productos",
      "customAmount" : "Cantidad personalizada",
      "collectPayment" : "Cobrar el pago",
      "generalSettings" : "Campos generales",
      "securePayments" : "*Bloquear y pagos seguros al 100%*",
      "error" : {
        "addMainProductFirst" : "Añadir a PRINCIPAL Producto primero",
        "priceNotFoundForBumpProduct" : "No se encontrado el Precio para el Producto ofrecido/complementario",
        "productAlreadyAdded" : "El Producto ya se ha añadido"
      },
      "product" : {
        "addProduct" : "Añadir producto",
        "productSettings" : "Configuración del producto",
        "bumpTag" : "Opción adicional",
        "settingsAria" : "Configuración del producto",
        "deleteAria" : "Eliminar producto",
        "selectProduct" : "Seleccionar producto",
        "editThisProduct" : "Para editar este producto",
        "clickHere" : "Haz clic aquí",
        "show" : "Mostrar",
        "description" : "Descripción",
        "image" : "Imagen",
        "layoutSettings" : "Configuración del diseño",
        "singleColumn" : "Columna única",
        "twoColumn" : "Dos columnas",
        "threeColumn" : "Tres columnas",
        "maxProductError" : "Se permiten un máximo de 20 productos en un formulario",
        "productSelectPlaceholder" : "Selecciona un producto",
        "orderConfirmation" : "Confirmación del pedido",
        "orderConfirmationWarning" : "La página de confirmación del pedido se mostrará una vez que el pago se haya realizado correctamente",
        "quantity" : "Cantidad",
        "createProduct" : "Para crear un producto",
        "noProductsAdded" : "Todavía no se han añadido productos",
        "productsWillShowHere" : "Una vez que estés incluido en los productos, se mostrarán Derecha aquí",
        "chooseProductType" : "Seleccionar Tipo de Producto",
        "mainProduct" : "PRINCIPAL Producto"
      },
      "bumProduct" : {
        "price" : "Precio",
        "variant" : "Variante",
        "headline" : "Titular",
        "otoHeadline" : "Titular de la OTO",
        "otoText" : "OTO Cuerpo",
        "enableImage" : "Habilitar Imagen",
        "imageMessage" : "Cogeremos el Por defecto Producto Imagen",
        "orUploadADifferentImage" : "O Subir a Imagen diferente",
        "bumpProducts" : "Productos complementarios",
        "bumpProduct" : "Producto ofrecido/complementario",
        "enableBump" : "Habilitar complementario",
        "orderBumpStyle" : "Estilo Venta adicional",
        "classic" : "Clásico",
        "modern" : "Moderno",
        "icon" : "Icono",
        "bumpTemplate" : "Seleccionar Plantilla",
        "highlightText" : "Destacar Cuerpo",
        "showPrice" : "Mostrar Precio",
        "bumpPriceColor" : "Precio adicional",
        "bumpIconColor" : "Icono de complemento",
        "bumpBackgroundColor" : "Fondo de relieve",
        "highlightTextColor" : "Destacar Cuerpo",
        "headlineColor" : "Titular",
        "otoHeadlineColor" : "Titular de la OTO",
        "otoTextColor" : "OTO Cuerpo",
        "bumpBorderColor" : "Borde",
        "priceRequired" : "El precio es obligatorio",
        "headlineRequired" : "El titular es obligatorio",
        "otoHeadlineRequired" : "El encabezado de OTO es obligatorio",
        "otoTextRequired" : "Se requiere OTO Text",
        "bumpProductTooltip" : "Un Pequeño Complemento ofrecido durante el Proceso de pago a Multiplicar Ordenar Valor. Los clientes pueden incluirlo en un clic de Individual .",
        "templateOne" : "Plantilla 1",
        "templateTwo" : "Plantilla 2",
        "templateThree" : "Plantilla 3",
        "animationIcon" : {
          "none" : "Ninguno",
          "arrow" : "Flecha",
          "fire" : "Fuego",
          "plus" : "Más",
          "giftBox" : "Caja de regalo",
          "timer" : "Cuenta atrás",
          "cracker" : "Cracker",
          "snack" : "Tentempié",
          "partyBalloon" : "Globo de fiesta",
          "flash" : "Flash",
          "money" : "Moneda",
          "spaceShuttle" : "Transbordador Espacio"
        }
      },
      "coupons" : {
        "coupons" : "Cupones",
        "enableCoupon" : "Habilitar cupón",
        "couponAlignment" : "Alineación de cupones",
        "left" : "Izquierda",
        "right" : "Derecha",
        "fullWidth" : "Ancho completo",
        "tooltipMessage" : "Determina la posición de la introducción de un cupón entre los siguientes tipos"
      }
    },
    "addressSettings" : {
      "autoComplete" : "Completar automáticamente la dirección",
      "addressfields" : "Campos de dirección",
      "placeholderSearch" : "Buscar una dirección",
      "autoCompleteTooltip" : "Ofrece la capacidad de buscar y completar automáticamente la dirección.",
      "streetAddress" : "Dirección postal",
      "autoCompleteAddressTitle" : "Automático Terminar dirección",
      "newBadge" : "Nuevo",
      "defaultLabel" : "Dirección",
      "searchPlaceholder" : "Buscar Dirección",
      "mandataorySearch" : {
        "title" : "Obligatorio para seleccionar la dirección in Buscar Bar",
        "primaryText" : "Autocompletar solo para la Dirección postal",
        "secondaryText" : "Cuando Habilitado, Cuando un Usuario interactúa con la Dirección Campo, Entonces debe seleccionar una Dirección válida para continuar.",
        "secondaryText1" : "Cuando Deshabilitado Entonces pueden Proceder sin seleccionar una Dirección in la barra Buscar."
      }
    },
    "autoResponder" : "Respuesta automática",
    "autoResponderSubheader" : "Enviar un correo electrónico automatizado a la persona que envía el formulario (el correo electrónico incluye una copia de la información que ha introducido en el formulario)",
    "replyToEmail" : "Responder al correo electrónico",
    "open" : "Abierto",
    "won" : "Ganado",
    "lost" : "Perdido",
    "abandon" : "Abandonar",
    "selectAPipeline" : "Selecciona una secuencia",
    "stage" : "Paso",
    "status" : "Estado",
    "opportunityValue" : "Valor del cliente potencial",
    "createNewPipeline" : "Crear una nueva secuencia",
    "editOpportunitySettings" : "Editar la configuración de clientes potenciales",
    "contact" : "Contacto",
    "opportunity" : "Cliente potencial",
    "business" : "Empresa",
    "add" : "Añadir",
    "manage" : "Gestionar",
    "more" : "Más",
    "opportunityHeading" : "¿Dónde quieres que se actualice tu oportunidad?",
    "date" : {
      "dateSettings" : "Configuración de fecha",
      "dateFormat" : "Formato de fecha",
      "dateSeparator" : "Separador de fechas",
      "dateFormatTooltipMessage" : "Selecciona un formato de fecha. D representa el día, M el mes e Y el año",
      "dateSeparatorTooltipMessage" : "Selecciona un separador para separar el día, el mes y el año en el formato seleccionado en el formato de fecha",
      "disablePicker" : "Desactivar selector"
    },
    "restoreVersion" : "Restaurar versión",
    "versionHistory" : "Historial de versiones",
    "errorMessage" : "Error, vuelve a intentarlo",
    "version" : "Versión:",
    "currentVersion" : "Versión actual",
    "messageStyling" : "Estilo del mensaje",
    "validateEmailHeader" : "Validar el correo electrónico",
    "validateEmailDescription" : "El botón se hará visible una vez que el usuario introduzca su correo electrónico. Esta función está diseñada para ayudarte a generar clientes potenciales de calidad.",
    "verifyEmail" : "Verificar el correo electrónico",
    "validatePhoneHeader" : "Validar el teléfono",
    "validatePhoneDescription" : "El botón se hará visible una vez que el usuario introduzca su teléfono. Esta función está diseñada para ayudarte a generar clientes potenciales de calidad.",
    "verifyPhone" : "Verificar teléfono",
    "validatePhoneWarning" : "Para habilitar la verificación OTP por SMS, asegúrate de que tu número de teléfono esté configurado en la configuración de tu ubicación",
    "addAnotherTnc" : "Añada otro término y condición",
    "tnc1" : "T y C 1",
    "tnc2" : "T y C 2",
    "deleteCaps" : "ELIMINAR",
    "deleteConfirmation" : "Escriba ELIMINAR para confirmar",
    "marginPadding" : "Margen y relleno",
    "style" : {
      "formLayoutType" : "Tipo de formulario",
      "layoutType" : "Tipo de Diseño",
      "surveyType" : "Tipo de encuesta",
      "oneColumn" : "Una columna",
      "twoColumn" : "Dos columnas",
      "singleLine" : "Una sola línea",
      "fieldWidth" : "Ancho de campo",
      "labelAlignment" : {
        "labelAlignment" : "Alineación de etiquetas",
        "labelWidth" : "Ancho de la etiqueta"
      },
      "fieldSpacing" : "Espaciado entre campos",
      "imageFieldSpacing" : "Imagen y espaciado de campo",
      "imageCornerRadius" : "Radio de la esquina de la imagen",
      "color" : "color",
      "fontColor" : "Color de la fuente",
      "inputBackgroundColor" : "Color de fondo del comentario",
      "inputBorder" : "Borde de comentario/opinión",
      "layout" : "Diseño",
      "colorsAndBackground" : "Colores y fondo",
      "imageLayout" : {
        "imageLayout" : "Alineación del contenido de la imagen",
        "showImage" : "Mostrar imagen",
        "image" : "Imagen",
        "desktop" : {
          "topFixed" : "Arriba fijo",
          "leftCenter" : "Izquierda Centrar",
          "rightCenter" : "Centrar a la derecha",
          "leftFixed" : "Fijo a la Izquierda",
          "rightFixed" : "Fijo a la derecha",
          "background" : "Fondo"
        },
        "mobile" : {
          "header" : "Encabezado",
          "background" : "Fondo"
        }
      },
      "focusPoint" : {
        "title" : "Punto Focal",
        "reset" : "Restablecer",
        "noImage" : "No se ha subido ninguna imagen"
      },
      "advanceSettings" : "Configuración avanzados",
      "inputField" : "Campo de entrada",
      "borderWidth" : "Ancho del borde",
      "borderColor" : "Color del borde",
      "borderStyle" : "Estilo de borde",
      "fontSize" : "Tamaño de la fuente",
      "fontWeight" : "Grosor de la fuente",
      "labelColor" : "Color de la etiqueta",
      "placeholderColor" : "Color del marcador de posición",
      "shortLabelColor" : "Color de etiqueta corta"
    },
    "replyToTooltip" : "Personaliza la dirección de correo electrónico predeterminada de Responder a mediante {'{'}{'{'}contact.email{'}'}{'}'} para habilitar las respuestas al contacto que envía el formulario.",
    "content" : "Contenido",
    "calculations" : "Cálculos",
    "uploadOptions" : "Opciones de subida",
    "opportunitySettingsWarning" : "Ajusta la configuración de oportunidades haciendo clic en el botón Edit Opportunity Settings.",
    "startValue" : "Valor de Inicio",
    "endValue" : "Valor de Finalización",
    "today" : "Hoy",
    "thisWeek" : "Esta semana",
    "last7Days" : "Últimos 7 días",
    "thisMonth" : "Este mes",
    "last30Days" : "Últimos 30 días",
    "question" : "Pregunta",
    "createContactOnPartialSubmission" : "Crear contacto en envío parcial",
    "howItWorks" : "¿Cómo funciona?",
    "createContactOnPartialSubmissionDescription" : "Termina la diapositiva y haz clic en «Next». Se creará y almacenará automáticamente un nuevo contacto.",
    "swapWarningMessageSurvey" : "Las opciones de edición o intercambio afectarán a este campo personalizado en todos los lugares donde se use el campo. También puede restablecer la lógica condicional. ",
    "swapWarningMessageForm" : "Editar o intercambiar opciones afectará a este campo personalizado en todos los lugares donde se use. ",
    "migrationWarningMessage" : "Esta funcionalidad se ha migrado a la lógica condicional de la encuesta.",
    "optionLabel" : "Etiqueta de opción",
    "calculationValue" : "Valor de cálculo",
    "addOption" : "Añadir opción",
    "enableCalculations" : "Activar cálculos",
    "allowOtherOption" : "Permitir otra opción",
    "productSelectionSubtext" : "Habilitar Individual O múltiple Selección de producto",
    "multi" : "Multi",
    "single" : "Individual",
    "productSelectionHeading" : "Selección de Producto",
    "spreadToColumns" : "Propagar a columnas",
    "columns" : "Columnas",
    "customstyle" : "Estilo",
    "standard" : "Estándar",
    "bubble" : "Bubble",
    "integratePopup" : {
      "title" : "Integrar formulario",
      "embedCode" : "Incrustar código",
      "useInFunnelOrEmbedCode" : "Uso en el embudo/código de inserción",
      "iframeEmbed" : "Insertar de iframe",
      "layout" : {
        "title" : "Incrustar tipo de diseño",
        "description" : "Seleccione un diseño para incrustarlo en un embudo o en un sitio web externo",
        "allowMinimize" : "Permitir minimizar",
        "minimizedTitlePlaceholder" : "Título minimizado",
        "leftAlignAlt" : "Alinear a la izquierda",
        "rightAlignAlt" : "Alinear a la derecha"
      },
      "triggerType" : "Tipo de activador",
      "triggers" : {
        "seconds" : "segundos"
      },
      "activation" : {
        "title" : "Opciones de activación",
        "visit" : "visitar"
      },
      "deactivation" : {
        "title" : "Opciones de desactivación",
        "times" : "veces"
      },
      "copyEmbedCode" : "Copiar el código de incrustación",
      "copyFormLink" : "Copiar el enlace del formulario",
      "openFormLink" : "Abrir el enlace del formulario",
      "invalidInput" : "¡Entrada no válida!",
      "funnel" : {
        "funnel" : "Embudo",
        "chooseStep" : "Seleccionar un paso",
        "copyCodeAndOpenFunnel" : "Copiar Código y Abrir Embudo"
      },
      "share" : {
        "share" : "Compartir",
        "shareViaSocials" : "Compartir Vía Redes sociales",
        "copyLink" : "Copiar enlace"
      },
      "email" : {
        "email" : "Correo electrónico",
        "shareViaEmail" : "Compartir Vía Correo electrónico",
        "emailButton" : "Correo electrónico",
        "blankTemplate" : "Plantilla en blanco",
        "emailMarketingTemplates" : "Plantillas de Marketing Correo electrónico",
        "or" : "O",
        "chooseTemplate" : "Elija entre sus plantillas",
        "continue" : "Continuar"
      }
    },
    "rating" : {
      "icon" : "Icono",
      "iconAlignment" : "Alineación de los Icono",
      "count" : "Recuento",
      "lowestRating" : "Mín. Valoración",
      "highestRating" : "Máx. Valoración",
      "iconSelectedState" : "Región/provincia/estado Seleccionado del Icono",
      "iconUnselectedState" : "Región/provincia/estado del Icono no seleccionado",
      "rating" : "Valoración",
      "ratingSettings" : "Configuración de Valoración",
      "calculationType" : {
        "calculationType" : "Cómo archivar Valoración Campos in Personalizado Campos",
        "calculationTypeTooltip" : "Cuando Tú Frecuencia algo 4 de 5 estrellas, significa: - Absoluto: 4 de 5 - Porcentaje: 80 - Fracción: 0,8",
        "absolute" : "Absoluto",
        "percentage" : "Porcentaje",
        "fraction" : "Fracción"
      }
    },
    "desktopMode" : "Modo de escritorio",
    "mobileMode" : "Modo móvil",
    "versions" : "Variantes",
    "advanced" : "Avanzado",
    "edit" : "Editar",
    "settings" : "Configuración",
    "submissions" : "Envíos",
    "undo" : "Deshacer",
    "redo" : "Rehacer",
    "customValues" : "Valores personalizados",
    "pickBgFromImage" : "Añade un difuminado al fondo del cuadro de mensaje. Si elige un color de fondo para el cuadro de mensaje, este aparecerá sobre el cuadro de mensaje difuminado.",
    "pickBgFromImageTip" : "Elija un Color con alto Comparar para la Imagen de fondo. Mensaje: No se aplicará si el Fondo del Formulario no tiene Imagen",
    "messageBackgroundBlur" : "Difuminado de fondo",
    "confirmationMessage" : "Mensaje de confirmación",
    "deleteOption" : "Opción de Borrar",
    "deleteConfirmationModal" : {
      "defaultDescription" : "Eliminar una opción afectará a este Campo Personalizado en todas las plazas donde se use el Campo. ¿Estás seguro de que deseas borrarlo?",
      "validationMessage" : "Introduce Borrar para guardar.",
      "validationError" : "Introduce Borrar"
    },
    "disqualifyImmediately" : "Descalificar inmediatamente",
    "disqualifyAfterSubmit" : "Descalificar después de enviar",
    "generalSettings" : "Configuración General",
    "advancedSettings" : "Configuración avanzados",
    "customFieldName" : "Personalizado Sector/industria Nombre",
    "customFieldNameTooltip" : "Este Nombre de sector/industria es único por Personalizado Sector/industria.",
    "uniqueKey" : "Clave única",
    "uniqueKeyTooltip" : "Esta clave es única por Personalizado Sector/industria.",
    "selectContactAssociation" : "Seleccione la asociación con los contactos",
    "associations" : "Asociaciones",
    "createNewAssociation" : "Crear una nueva Relación",
    "selectAnAssociation" : "Seleccionar una asociación",
    "loadingAssociations" : "Cargando asociaciones...",
    "unknownAssociation" : "Asociación Desconocida",
    "manyToMany" : "Muchos a Muchos",
    "failedToLoadAssociations" : "No se han podido cargar las asociaciones.",
    "noAssociationsFound" : "No se han encontrado relaciones",
    "keepThisField" : "Mantener este Sector/industria",
    "association" : "Asociación",
    "customObject" : "Objeto personalizado",
    "customObjects" : "Objetos personalizados",
    "object" : "Objeto",
    "editAssociation" : "Editar Relación {objectName}",
    "editAssociationButton" : "{edit} {objectName} {association}",
    "fields" : "Campos",
    "primaryFieldWarning" : "{fieldName} es un campo PRINCIPAL para {objectSingular} y es Obligatorio para crear O Actualizar un {objectSingular}.",
    "primaryFieldTitle" : "{fieldName} es Obligatorio para crear o Actualizar el Documento {objectSingular}.",
    "removeAllFields" : "Borrar todos los Campos {objectSingular}",
    "customObjectsFallback" : "Objetos personalizados",
    "noneAssociation" : "Ninguno",
    "noneAssociationDescription" : "No hay relación con los Contactos (no hay Campos de Contacto aquí)",
    "survey" : {
      "layoutType" : "Tipo de Encuesta",
      "oneQuestionPerPage" : "Una pregunta a la vez",
      "allQuestionsOnePage" : "Muchos a la Vez"
    },
    "quizQuestions" : "Cuestionario Consultar",
    "choiceElements" : "Componentes seleccionados",
    "otherElements" : "Otro Componentes",
    "listEditor" : {
      "prefillValueHeader" : "Valor de Prerrellenar",
      "labelPlaceholder" : "Etiqueta",
      "valuePlaceholder" : "Valor",
      "optionRequiredError" : "La opción Campo es Obligatorio"
    },
    "field" : "Campo",
    "scoreEditor" : {
      "addFieldPlaceholder" : "Añadir Campo",
      "fieldLabel" : "Campo",
      "numberLabel" : "número"
    },
    "fileUploadEditor" : {
      "fileTypes" : "Tipos de Archivo",
      "all" : "cada",
      "pdf" : "PDF",
      "docxDoc" : "DOCX/DOC",
      "png" : "PNG",
      "gif" : "GIF",
      "jpgJpeg" : "JPG/JPEG",
      "xlsCsv" : "XLS/CSV"
    },
    "ok" : "De acuerdo",
    "allowMultipleFiles" : "Habilitar múltiples Archivos",
    "maxFileLimit" : "Límite Máx. de Archivo",
    "privacyPolicy" : "Política de privacidad",
    "termsOfService" : "Condiciones del servicio",
    "colorPicker" : {
      "brandColors" : "Colores de marca",
      "defaultColors" : "Colores por defecto",
      "globalCustomColors" : "Colores globales personalizados"
    },
    "billingFrequency" : "Frecuencia de Facturación",
    "otherAmount" : "Otra cantidad",
    "exampleUrlPlaceholder" : "https://www.ejemplo.com",
    "checkboxStyles" : {
      "standardAlt" : "Estilo estándar de casilla de verificación",
      "bubbleAlt" : "Estilo de casilla de verificación tipo burbuja"
    },
    "previewIcons" : {
      "exportAlt" : "Icono de exportación",
      "shipmentAlt" : "Icono de envío",
      "resultAlt" : "Icono de la página de resultados"
    },
    "examples" : {
      "sampleUrl" : "https://ejemplo.com"
    },
    "showing" : "Mostrando",
    "of" : "de",
    "enterCouponCode" : "Introducir el código del cupón",
    "apply" : "Aplicar",
    "paymentWillBeProcessed" : "El pago se procesará en cuanto usted continúe con el siguiente paso",
    "paymentWillBeProcessedNextSlide" : "El pago se procesará en cuanto el usuario avance a la siguiente diapositiva",
    "showThisAlertToUsers" : "Mostrar esta alerta a los usuarios",
    "sixteenDigitCardNumber" : "Número de tarjeta de 16 dígitos",
    "mmYy" : "MM / AA",
    "cvc" : "CVC",
    "pleaseFillRequiredFields" : "Rellene todos los campos obligatorios.",
    "opportunitySettingsIncomplete" : "Configuración de la oportunidad incompleta",
    "opportunitySettingsIncompleteDescription" : "Este formulario incluye campos de Oportunidad, pero la configuración de la oportunidad no se ha actualizado. Configure la oportunidad para poder guardar el formulario",
    "ariaAttributes" : {
      "iconSearch" : "Búsqueda de iconos"
    },
    "alt" : {
      "standardRadioStyle" : "Estilo del botón de opción estándar",
      "bubbleRadioStyle" : "Estilo del botón de opción en burbuja"
    },
    "value" : "Valor",
    "jumpTo" : "Saltar a",
    "thankYouJohnDoe" : "Gracias, Juan Pérez",
    "total" : "Total",
    "urlExamples" : {
      "simple" : "ejemplo.com",
      "https" : "https://ejemplo.com",
      "withPath" : "example.com/path",
      "fullPath" : "https://www.ejemplo.com/path"
    }
  },
  "fields" : {
    "quizQuestions" : {
      "singleChoice" : "Elección Individual",
      "multipleChoice" : "Elección múltiple",
      "yesNo" : "Sí / No",
      "shortAnswer" : "Corto Respondido",
      "longAnswer" : "Respondido largo",
      "number" : "número",
      "singleDropdown" : "Menú desplegable Individual",
      "multiDropdown" : "Menú desplegable múltiple"
    },
    "personal" : {
      "fullName" : "Nombre Completo",
      "firstName" : "Nombre",
      "lastName" : "Apellidos",
      "dateOfBirth" : "Fecha de nacimiento",
      "phone" : "Teléfono",
      "email" : "Gmail"
    },
    "submit" : {
      "button" : "Botón"
    },
    "integration" : {
      "sellProducts" : "Vender productos",
      "collectPayment" : "Cobrar el Pago"
    },
    "address" : {
      "address" : "Dirección",
      "streetAddress" : "Dirección postal",
      "city" : "Ciudad",
      "state" : "Región/provincia/estado",
      "country" : "País",
      "postalCode" : "Código postal",
      "organization" : "Grupo",
      "website" : "Sitio web",
      "websitePlaceholder" : "La URL web va aquí"
    },
    "text" : {
      "singleLine" : "Línea Individual",
      "multiLine" : "Multi Línea",
      "textBoxList" : "Lista de cuadros de texto"
    },
    "choiceElements" : {
      "singleDropdown" : "Menú desplegable Individual",
      "multiDropdown" : "Menú desplegable múltiple",
      "checkbox" : "Casilla de verificación",
      "radio" : "Botón de opción"
    },
    "customized" : {
      "text" : "Haga clic para editar este texto",
      "html" : "Html",
      "htmlPlaceholder" : "El HTML Personalizado va aquí",
      "captcha" : "Captcha",
      "source" : "Fuente",
      "termsAndConditions" : "Términos y condiciones",
      "termsAndConditionsPlaceholder" : "Acepto los términos y condiciones Emitido Vía la empresa. Vía proporcionando mi Número de teléfono, acepto a Heredar Enviar mensaje de texto mensajes De la empresa.",
      "score" : "Puntuación"
    },
    "other" : {
      "image" : "Imagen",
      "fileUpload" : "Subir de Archivo",
      "monetary" : "Monetario",
      "number" : "número",
      "datePicker" : "Selector de Fecha",
      "signature" : "Firma"
    },
    "customstyle" : "Estilo",
    "standard" : "Estándar",
    "bubble" : "Bubble"
  },
  "survey" : {
    "typeOfBuilder" : "Encuesta",
    "survyeStyle" : "Estilo de encuesta",
    "surveyName" : "Nombre de encuesta",
    "surveyElement" : "Elemento de encuesta",
    "addSurveyElement" : "Añadir elemento de encuesta",
    "cloneSlide" : "Clonar diapositiva",
    "unsavedAlertMessage" : "Hay trabajo sin guardar en la encuesta. ¿Seguro que quieres abandonar y descartar todo el trabajo que no has guardado?",
    "thirdPartyScriptAlertMessage" : "Las secuencias de código de terceros dentro del bloque HTML pueden proporcionar una funcionalidad potente, pero también conllevan riesgos para la privacidad, la seguridad, el rendimiento y el comportamiento de la página. Por lo tanto, te recomendamos que revises el contenido de este script antes de guardarlo en la encuesta.",
    "integrateHeader" : "Integrar encuesta",
    "integrateSubHeader" : "Usa las siguientes opciones para integrar tu encuesta personalizada en tu sitio web",
    "integrateCopyLinkMessage" : "Copia el enlace a continuación y compártelo fácilmente donde quieras.",
    "onSurveySubmission" : "En el envío de encuestas",
    "surveySettings" : "Configuración de la encuesta",
    "oneQuestionAtTime" : "Una pregunta cada vez",
    "backButton" : "Botón de retroceso",
    "backButtonTooltipMessage" : "El botón «Atrás» ayudará a los usuarios a pasar a la diapositiva anterior",
    "disableAutoNavigation" : "Desactivar la navegación automática",
    "disableAutoNavigationTooltipMessage" : "Navega automáticamente al Siguiente Deslizar Después a Usuario responde.",
    "autoNavigation" : "Navegación Automático",
    "autoNavigationTooltipMessage" : "Navega automáticamente al Siguiente Deslizar Después a Usuario responde.",
    "progressBar" : "Barra de progreso",
    "progressBarTooltipMessage" : "Al desactivar esta opción, se eliminará la barra de progreso de la encuesta",
    "disableAnimation" : "Desactivar la animación",
    "disableAnimationTooltipMessage" : "Al activar esta opción, se desactivará la animación de transición de la diapositiva",
    "scrollToTop" : "Desplazarse hasta arriba",
    "scrollToTopTooltipMessage" : "Si esta opción está activada, la encuesta se desplazará hasta la parte superior de la siguiente diapositiva",
    "submitSurvey" : "Enviar encuesta",
    "disqualifyImmediately" : "Descalificar inmediatamente",
    "disqualifyAfterSubmit" : "Descalificar después de enviar",
    "disqualifyAfterSubmitLowerCase" : "Descalificar después de enviar",
    "footerHTML" : "Pie de página HTML",
    "footerHTMLMessage" : "Puedes escribir CSS personalizado (usando una etiqueta de estilo) y HTML dentro del mismo cuadro",
    "editFooter" : "Editar pie de página",
    "disqualifySettings" : "Descalificar los ajustes",
    "disqualifyImmediatelyLabel" : "Inmediatamente",
    "disqualifyAfterSubmitLabel" : "Tras el envío",
    "slideConflictAlertMessage" : "Esta diapositiva contiene varias preguntas que tienen una lógica establecida. Esto puede provocar algún comportamiento no deseado.",
    "addSlide" : "Añadir diapositiva",
    "settings" : "Configuración",
    "delete" : "Eliminar",
    "slideDeleteAlertMessage" : "¿Seguro que quieres eliminar esta diapositiva?",
    "slideDeleteBetweenAlertMessage" : "Esta acción reorganizará las demás diapositivas. ¿Seguro que quieres eliminar esta diapositiva?",
    "slideLabel" : "Diapositiva {n}",
    "slideName" : "Nombre de la diapositiva",
    "slidePosition" : "Posición de diapositiva",
    "jumpTo" : "Saltar a",
    "jumpToSubText" : "Vaya a una diapositiva específica",
    "enableTimezoneSurvey" : "Al activar esta opción, se capturará la información de la zona horaria de la persona que envía la encuesta.",
    "footer" : {
      "footer" : "Pie de página",
      "enableNewFooter" : "Habilitar nuevo pie de página",
      "stickToSurvey" : " Cíñete a la encuesta",
      "backgroundFill" : "Relleno de fondo",
      "footerHeight" : "Altura del pie de página",
      "enableProgressBar" : "Habilitar la barra de progreso",
      "buttons" : "Botones",
      "button" : "Botón",
      "buttonType" : "Tipo de botón",
      "fillNext" : "Rellenar (siguiente)",
      "fillPrevious" : "Rellenar (anterior)",
      "fillSubmit" : "Rellenar (Enviar)",
      "textColor" : "Texto del botón",
      "position" : "Posición",
      "previousText" : "Anterior (texto)",
      "nextText" : "Siguiente (texto)",
      "submitText" : "Enviar (texto)",
      "fillComplete" : "Rellenar completado",
      "fillInactive" : "Rellenar inactivo",
      "footerType" : "Tipo de pie de página",
      "stickToCard" : "Fijar a la tarjeta",
      "stickToPage" : "Fijar a la página",
      "stepTextColor" : "Paso Cuerpo Color",
      "progressBarFill" : "Barra de progreso Rellenar",
      "progressBarInactive" : "Barra de progreso Inactivo",
      "arrowFill" : "Rellenar de Flecha",
      "submitColorMobile" : "Enviar (Color)",
      "arrowFillColor" : "Color de Rellenar de la Flecha",
      "buttonTypes" : {
        "textAndArrow" : "Texto & Flecha",
        "onlyText" : "Solo texto",
        "onlyArrow" : "Solo flecha"
      },
      "positions" : {
        "leftAndRight" : "Izquierda y derecha"
      },
      "placeholders" : {
        "prev" : "Anterior",
        "next" : "Siguiente",
        "submit" : "Enviar"
      }
    },
    "surveyNotfication" : "Notificación de encuesta",
    "style" : {
      "surveyPadding" : "Margen de la encuesta"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Incrustar o compartir encuesta",
      "share" : {
        "openFormLink" : "Abrir Enlace de la Encuesta"
      },
      "email" : {
        "emailSubheader" : "Crea un correo electrónico en blanco e inserta tu encuesta, O selecciona una plantilla e insértala inmediatamente."
      }
    },
    "autoResponderSubheader" : "Enviar un correo electrónico automatizado a la persona que envía el formulario (el correo electrónico incluye una copia de la información que ha introducido en el formulario)",
    "sendSubmissionsAsPdf" : "Enviar el envío de encuesta en formato PDF",
    "switchToOneQuestionAtTimeOn" : "Habilitar «Una pregunta por fecha» interrumpe tu Lógica del condicional real",
    "switchToOneQuestionAtTimeOff" : "Deshabilitar «Una pregunta a la fecha» afecta a tu Lógica Config. condicional.",
    "switchToOneQuestionAtTimeOnWarning" : "Algunas condiciones ya no funcionarán como se esperaba Cuando las preguntas son asistidos una a una Fecha.",
    "switchToOneQuestionAtTimeOffWarning" : " Algunas condiciones diseñadas para Flujo de preguntas individuales dejarán de funcionar correctamente.",
    "createContactOnPartialSubmissionSubText" : "Crea un contacto cuando un usuario hace clic en «Siguiente» en cualquier diapositiva, aunque no termine la encuesta.",
    "dragDrop" : {
      "imageLabel" : "Imagen {n}",
      "htmlLabel" : "HTML {n}",
      "defaultFolderName" : "Encuesta {'|'} {name}",
      "defaultTermsHtml" : "<p style=\"text-align: center\"><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Política de privacidad</a> | <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Términos de servicio</a></p>",
      "smsConsent" : "Consiento recibir notificaciones por SMS, alertas y comunicaciones de marketing ocasionales de la empresa. La frecuencia de los mensajes varía. Pueden aplicarse tarifas de mensajes y datos. Envíe AYUDA al (XXX) XXX-XXXX para obtener asistencia. Puede responder DETENER para cancelar la suscripción en cualquier momento."
    }
  },
  "form" : {
    "typeOfBuilder" : "Formulario",
    "formStyle" : "Estilo del formulario",
    "formElement" : "Elemento de formulario",
    "addFormElement" : "Añadir elemento de formulario",
    "addConditionalLogic" : "Añadir lógica condicional",
    "openConditionalLogic" : "Abrir la lógica condicional",
    "inlineForm" : "Formulario en línea",
    "formName" : "Nombre del formulario",
    "fullScreenMode" : "Modo de pantalla completa",
    "fullScreenModetooltip" : "Si esta opción está activada, el formulario se expandirá por todo el ancho de su contenedor y se extenderá hasta el borde del área de incrustación sin sobrepasar el ancho del formulario.",
    "enableTimezoneForm" : "Al activar esta opción, se capturará la información de la zona horaria de la persona que envía el formulario",
    "formSettings" : "Configuración del formulario",
    "unsavedAlertMessage" : "Hay trabajo sin guardar en el formulario. ¿Seguro que quieres abandonar y descartar todo el trabajo que no has guardado?",
    "thirdPartyScriptAlertMessage" : "Las secuencias de código de terceros dentro del bloque HTML pueden proporcionar una funcionalidad potente, pero también conllevan riesgos para la privacidad, la seguridad, el rendimiento y el comportamiento de la página. Por lo tanto, te recomendamos que revises el contenido de este script antes de guardarlo en la encuesta.",
    "onFormSubmission" : "En el envío del formulario",
    "integrateForm" : "Integrar formulario",
    "embedlayoutType" : "Tipo de Diseño Insertar",
    "embedlayoutTypeSubMessage" : "Selecciona un diseño para incrustarlo en un embudo o en un sitio web externo",
    "triggerType" : "Tipo de activador",
    "showOnScrolling" : "Mostrar al desplazarse",
    "showAfter" : "Mostrar después",
    "seconds" : "segundos",
    "alwaysShow" : "Mostrar siempre",
    "activationOptions" : "Opciones de activación",
    "activateOn" : "Activar el",
    "visit" : "visitar",
    "alwaysActivated" : "Siempre activado",
    "deactivationOptions" : "Opciones de desactivación",
    "deactivateAfterShowing" : "Desactivar después de mostrar",
    "times" : "veces",
    "deactiveOnceLeadCollected" : "Desactivar una vez que se haya recopilado el cliente potencial",
    "neverDeactivate" : "No desactivar nunca",
    "copyEmbedCode" : "Copiar código de incrustación",
    "copyFormLink" : "Copiar enlace del formulario",
    "openFormLink" : "Abrir enlace del formulario",
    "inline" : "En línea",
    "inlineDescription" : "Aparece un formulario en línea junto con el contenido de la página como elemento nativo. No se superpone y no se puede cerrar ni minimizar.",
    "inlineHoverDescription" : "Aparece un formulario en línea junto con el contenido de la página como elemento nativo. No se superpone y no se puede cerrar ni minimizar.",
    "popup" : "Ventana emergente",
    "popupDescription" : "Una ventana emergente muestra el formulario como una superposición dentro de una caja de luz. No se puede minimizar, pero sí cerrar.",
    "popupHoverDescription" : "Una ventana emergente muestra el formulario como una superposición dentro de una caja de luz. No se puede minimizar, pero sí cerrar.",
    "politeSlideIn" : "Ventana deslizante respetuosa",
    "politeSlideInDescription" : "Aparece una ventana deslizante en la parte inferior de la pantalla, que desaparece una vez cerrada.",
    "politeSlideInHoverDescription" : "Aparece en la parte inferior de la pantalla y desaparece una vez cerrada",
    "stickySidebar" : "Barra lateral fija",
    "stickySidebarDescription" : "Aparecerá una barra lateral fija en el lateral de la pantalla que puede minimizarse para convertirse en una pestaña fijada al lateral de la ventana",
    "stickySidebarHoverDescription" : "Aparecen en el lateral de la pantalla y pueden minimizarse para convertirse en una pestaña fijada al lateral de la ventana",
    "allowMinimize" : "Permitir minimizar",
    "conditonalLogic" : {
      "conditions" : "Condiciones",
      "noExistingCondition" : "Todavía no existen condiciones",
      "freeRoamMessage" : "Puedes ir por libre sin reglas… al menos, por ahora.",
      "addNewCondition" : "Añadir nueva condición",
      "redirectToUrl" : "Redirigir a la URL",
      "displayCustomMessage" : "Mostrar un mensaje personalizado",
      "disqualifyLead" : "Descalificar al cliente potencial",
      "showHideFields" : "Mostrar/Ocultar campos",
      "jumpTo" : "Saltar a",
      "redirectToUrlSubText" : "Redirigir al usuario después del envío",
      "displayCustomMessageSubText" : "Mostrar mensajes basados en las entradas de Activado Usuario",
      "disqualifyLeadSubText" : "Filtrar las entradas bajo condiciones específicas",
      "showHideFieldsSubText" : "Modificar el campo de visibilidad dinámicamente",
      "openBelowUrl" : "Abre la URL a continuación",
      "showCustomMessage" : "Mostrar mensaje personalizado",
      "alertConditionDelete" : "¿Seguro que quieres eliminar esta condición?",
      "deleteCondition" : "Eliminar condición",
      "conditionExecutedMessage" : "Las condiciones se ejecutarán en orden descendente.",
      "allOperationOptions" : {
        "isEqualTo" : "Es igual a",
        "isNotEqualTo" : "No es igual a",
        "contains" : "Contiene",
        "doesNotContain" : "No contiene",
        "startsWith" : "Empieza por",
        "endsWith" : "Termina con",
        "isEmpty" : "Está vacío",
        "isFilled" : "Está rellenado",
        "before" : "Antes",
        "after" : "Después",
        "greaterThan" : "Mayor que",
        "lessThan" : "Menor que",
        "between" : "Entre",
        "isChecked" : "Está marcado",
        "isNotChecked" : "No está seleccionado"
      },
      "logic" : {
        "if" : "Si",
        "then" : "Entonces",
        "and" : "Y",
        "or" : "O"
      },
      "phoneAlertMessage" : "Para buscar números de teléfono con un código de país, debes incluir explícitamente el símbolo «+» en la consulta de búsqueda.",
      "deleteAlertMessage" : "¿Seguro que quieres eliminar este campo? También se eliminará la condición asociada a este campo.",
      "deleteField" : "Eliminar campo",
      "jumpToDescription" : "Saltar a una diapositiva específica cuando se cumplen las condiciones",
      "cycleError" : "No se puede guardar. Bucle detectado entre {a} y {b}",
      "jumpToSlide" : "Saltar a la diapositiva",
      "submitSurvey" : "Guardar Encuesta",
      "pageTitle" : "P{index} - {title}",
      "selectSlideToJumpTo" : "Hacer clic en Deslizar de la que desea saltar",
      "selectedSlide" : "Diapositiva seleccionada",
      "typeValueHere" : "Por favor, escriba un Valor aquí",
      "field" : "Campo",
      "slide" : "Deslizar",
      "selectFieldOrSlide" : "Seleccionar Sector/industria o Deslizar",
      "selectFieldState" : "Seleccionar Estado del Campo",
      "selectField" : "Seleccionar campo",
      "selectOption" : "Seleccionar Opción",
      "jumpToTarget" : "Saltar a",
      "jumpToQuestion" : "Ir a la Pregunta",
      "chooseQuestion" : "Seleccionar Pregunta",
      "includeStart" : "Incluir inicio",
      "includeEnd" : "Incluir al final",
      "includeValue" : "Incluir {value}",
      "hideField" : "Ocultar Campo",
      "hideFields" : "Ocultar campos",
      "showField" : "Mostrar campo",
      "showFields" : "Mostrar Campos",
      "additionalRulesPrefix" : "... y",
      "additionalRulesSuffix" : "otras reglas de {ifLabel}...",
      "shownTargetsWithMore" : "{shown}, +{count} más",
      "noConditionsAlt" : "Todavía no hay condiciones",
      "outcomeLabels" : {
        "show" : "Mostrar",
        "jumpTo" : "Saltar a"
      }
    },
    "minimizedTitlePlaceholder" : "Título minimizado",
    "dragYourElementFromLeft" : "Arrastra tus elementos aquí desde la izquierda",
    "formNotification" : "Notificación del formulario",
    "sendSubmissionsAsPdf" : "Enviar el formulario como PDF",
    "style" : {
      "formPadding" : "Margen del formulario"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Incrustar o compartir formulario",
      "share" : {
        "openFormLink" : "Abrir Enlace del Formulario"
      },
      "email" : {
        "emailSubheader" : "Crea un correo electrónico en blanco e inserta tu formulario, O selecciona una plantilla e insértala inmediatamente."
      }
    },
    "choosePosition" : "Seleccionar Estado",
    "testBuild" : "Compilación de prueba"
  },
  "quiz" : {
    "quizElement" : "Elemento del cuestionario",
    "quizNotification" : "Notificación del cuestionario",
    "viewAndCustomise" : "Ver y personalizar",
    "categoryAndScore" : "Categoría y puntuación",
    "provideFeedback" : "Proporcionar comentarios",
    "addQuizElement" : "Añadir elemento del cuestionario",
    "typeOfBuilder" : "Cuestionario",
    "addQuestions" : "Añadir preguntas",
    "dragAndDropQuestion" : "Arrastrar y suelta aquí un elemento de Pregunta .",
    "addNewPage" : "Añadir Nueva página",
    "editTemplate" : "Editar Plantilla",
    "editResultPage" : "Editar la página de resultados",
    "clonePage" : "Clonar página",
    "category" : {
      "category" : "Categoría",
      "watchVideo" : "¡Mira este vídeo para obtener más información Acerca de cómo la categoría afecta a los resultados Página!",
      "useCategoryWhen" : "Utilizar categorías Cuando",
      "manageCategories" : "Gestionar las Categorías",
      "howItWorks" : "¿Cómo funciona esto? 🤔",
      "howItWorks2" : "Cómo funciona esto",
      "addCategoryMessage" : "Añadir a nueva categoría",
      "assignCategoryMessage" : "Asignar una categoría a cada opción",
      "editResultsMessage" : "Mostrar la categoría puntuación in el Resultado página",
      "addCategory" : "Añadir Categoría",
      "deleteCategoryAlertMessage" : "Eliminar una categoría dará como resultado el resto de esa categoría in cada opciones",
      "editOrAddNewCategories" : "Tú puedes Editar o incluir nuevas categorías",
      "toEvaluateTheResponder" : "Para comparar el respondedor en función de Activado, varios factores",
      "showMultipleCategoryScore" : "Mostrar múltiples categorías de puntuación in el Resultado página",
      "displayVaryingContent" : "Visualización variando el Contenido Activado de los resultados Página según Activado la Categoría nivel de puntuación",
      "theOptionFieldIsRequired" : "El campo de opción es obligatorio",
      "addManage" : "Añadir / Gestionar",
      "enterCategoryPlaceholder" : "Introduzca el nombre de la categoría",
      "carouselAlt" : "Diapositiva de vista previa de categoría"
    },
    "quizSettings" : "Configuración del cuestionario",
    "onQuizSubmission" : "En el envío del cuestionario",
    "settings" : "Configuración",
    "deletePage" : "Eliminar página",
    "quizResult" : {
      "resultTemplate" : "Plantilla de resultados",
      "quizResultAlertMessage" : "La página de resultados elegida se mostrará una vez finalizado el cuestionario",
      "overallScoreLabel" : "Puntuación general"
    },
    "autoResponderSubheader" : "Enviar un correo electrónico automatizado a la persona que envía el cuestionario (el correo electrónico incluye una copia de la información que ha introducido en el cuestionario)",
    "sendSubmissionsAsPdf" : "Enviar el cuestionario como PDF",
    "sendQuizResultsAsPdf" : "Enviar el resultado del cuestionario como PDF",
    "integrateHeader" : "Integrar cuestionario",
    "integrateSubHeader" : "Usa las siguientes opciones para integrar tu cuestionario personalizado en tu sitio web",
    "integrateCopyLinkMessage" : "Copia el enlace a continuación y compártelo fácilmente donde quieras.",
    "pageLabel" : "Página {n}",
    "pageName" : "Nombre de la página",
    "pagePosition" : "Posición de la página",
    "createContactOnPartialSubmissionSubText" : "Crea un contacto cuando un usuario hace clic en «Siguiente» en cualquier diapositiva, aunque no termine el cuestionario.",
    "integratePopup" : {
      "shareOrEmbed" : "Incrustar o compartir cuestionario",
      "share" : {
        "openFormLink" : "Abrir Enlace del cuestionario"
      },
      "email" : {
        "emailSubheader" : "Crea un Correo electrónico en blanco e Insertar tu cuestionario, O Seleccionar una Plantilla e Insertarla inmediatamente."
      }
    }
  },
  "textEditor" : {
    "textAlign" : "Alineación de texto",
    "list" : "Lista",
    "sourceCode" : "Código fuente",
    "resetStyle" : "Restablecer estilo",
    "resetDocumentStyle" : "Restablecer el estilo del documento"
  }
}
